module.exports = __webpack_public_path__ + "img/bonus-text-bg.b0ace51.b0ace51a.png";